const LT_WWW_URL = 'https://www.lendingtree.com';
const LT_WWW_SPITTER_URL = 'https://www.lendingtree.com/redirect/offers?id=';
const MYLT_URL = 'https://spring.lendingtree.com';

export default {
    LT_WWW_URL, LT_WWW_SPITTER_URL, MYLT_URL,
};
